import Hero from './components/Hero';
import BusinessProblems from './components/BusinessProblems';
import Insight from './components/Insight';
import WhenToChoose from './components/WhenToChoose';
import ProcessSteps from './components/ProcessSteps';
import SystemsWeBuild from './components/SystemsWeBuild';
import Positioning from './components/Positioning';
// @ts-ignore
import { useAutoSEO } from '../../hooks/useSEOFromRoute';

export default function CustomSoftwareDevelopmentPage() {
  // Auto fetch SEO from database based on route
  useAutoSEO();

  return (
    <div className="relative">
      <Hero />
      <BusinessProblems />
      <Insight />
      <WhenToChoose />
      <ProcessSteps />
      <SystemsWeBuild />
      <Positioning />
    </div>
  );
}